import { render, staticRenderFns } from "./SafetyObservationEditForm.vue?vue&type=template&id=8771ac68&scoped=true"
import script from "./SafetyObservationEditForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationEditForm.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationEditForm.vue?vue&type=style&index=0&id=8771ac68&prod&lang=css"
import style1 from "./SafetyObservationEditForm.vue?vue&type=style&index=1&id=8771ac68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8771ac68",
  null
  
)

export default component.exports